import React from 'react'
import { FormSection } from 'redux-form'
import { defaultTo, equals, length, not } from 'ramda'
import { Divider, Button, Icon } from 'antd'
import ChangePasswordForm from './ChangePasswordForm'
import { isEmptyOrNull } from '../../../../utils/helpers'

const ChangePassword = ({ changePassword, formValues }) => {

  const {
    changePassword: {
      newPassword,
      confirmPassword,
      currentPassword
    }
  } = defaultTo({}, formValues)

  const currentPasswordNotFound = isEmptyOrNull(currentPassword)
  const passwordNotMatched = not(equals(newPassword, confirmPassword))
  const inavlidPasswordLength = length(newPassword) < 8
  const capitalCharNotFound = not(/[A-Z]/.test(newPassword))
  const numericCharNotFound = not(/[0-9]/.test(newPassword))

  const invalidForm = currentPasswordNotFound ||
                      passwordNotMatched ||
                      inavlidPasswordLength ||
                      capitalCharNotFound ||
                      numericCharNotFound

  const handleSubmit = event => {
    event.preventDefault()

    if(!invalidForm && changePassword){
      changePassword()
    }
  }

  return (
    <div>
      <div className="inner-wrapper">
        <div className="steps-content">
          <div className="steps-header">
            <h3>Security</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <FormSection name="changePassword">
              <Divider>Change Password</Divider>
              <div className='change-password-div'>
                <ChangePasswordForm />
              </div>
            </FormSection>
            <Button
              className="success-btn content-submit-btn"
              htmlType="submit"
              shape="round"
              disabled={invalidForm}
            >
              <Icon type="check" />
              Save
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
